import EDFError from './edf.error';

export default class FatalError extends EDFError {
    constructor(message: string, cause?: Error) {
        super(message, 'EDF:FatalError', cause);
    }
}
